import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import InputMask from 'react-input-mask';

class TrainingCertificationStaffDailiesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      training_id: this.props.training_id,
      data: [],
    };

    //bind específico
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.training_certification_staff_dailies)) {
      this.setState({
        data: newProps.training_certification_staff_dailies,
        loaded: 1
      });
    }
  }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/registros/' + self.state.training_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/registros/pendentes/' + self.state.training_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Registros de realização de treinamento</h3>
  <hr/>
  <button className="btn btn-sm btn-warning btn-block" onClick={self.state.only_active === 0 ? self.refreshDataActive.bind(self, self.state.data) : self.refreshData.bind(self, self.state.data)}>{self.state.only_active === 0 ? "Esconder confirmados" : "Mostrar confirmados"}</button>
  <hr/>
  {(this.state.data === null || typeof this.state.data === 'undefined') ?  <div><small><em>{'Registros não encontrados'}</em></small><hr/></div>
  :
  <div>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText:'Exportar CSV', noDataText: 'Registros não encontrados', defaultSortName: 'id', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder={"Procurar"}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{"ID"}</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{"Matrícula"}</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='500'>{"Nome"}</TableHeaderColumn>

        <TableHeaderColumn dataField="training_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>{"Treinamento"}</TableHeaderColumn>

        <TableHeaderColumn dataField="certification_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='300'>{"Aula"}</TableHeaderColumn>

        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{"Data"}</TableHeaderColumn>

        <TableHeaderColumn dataField="showup_hours_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='220'>{"Apresentacao"}</TableHeaderColumn>

        <TableHeaderColumn dataField="start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='220'>{"Inicio"}</TableHeaderColumn>

        <TableHeaderColumn dataField="finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='220'>{"Termino"}</TableHeaderColumn>

        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{"Status"}</TableHeaderColumn>

      </BootstrapTable>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default TrainingCertificationStaffDailiesTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationStaffDailiesTab.js